
















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DxPieChart, {
  DxLegend,
  DxSeries,
  DxTooltip,
  DxFormat,
  DxLabel,
  DxConnector,
  DxExport,
  DxSize,
  DxBorder,
  DxCommonSeriesSettings,
} from 'devextreme-vue/pie-chart';

import { localize } from '@/core/filters';
import { IRequestsData, LocalizationKeys, RequestDiagramColors } from '../classes';

@Component({
    components: {
        DxPieChart,
        DxLegend,
        DxSeries,
        DxTooltip,
        DxFormat,
        DxLabel,
        DxConnector,
        DxExport,
        DxSize,
        DxBorder,
        DxCommonSeriesSettings,
    }
})
export default class ExpandedRequestsChart
    extends Vue {

    public RequestDiagramColors = RequestDiagramColors;
    public LocalizationKeys = LocalizationKeys;

    @Prop({ required: true, })
    public requestsData?: IRequestsData;

    private mounted(): void {
        if (!this.requestsData) { throw new Error('requestsData is not set'); }
    }

    private get values(): { label: string, value: number }[] {
        return [
            {
                label: localize(LocalizationKeys.ConsumptionsWithoutDelay),
                value: this.consumptionsCountWithoutDelay,
            }, {
                label: localize(LocalizationKeys.ConsumptionsWithDelay),
                value: this.consumptionsCountWithDelay,
            }, {
                label: localize(LocalizationKeys.ConsumptionsPostponed),
                value: this.consumptionsCountPostponed,
            },
        ];
    }
    private get consumptionsCountWithoutDelay(): number {
        return this.requestsData!.countWithoutDelay;
    }
    private get consumptionsCountPostponed(): number {
        return this.requestsData!.countPostponed;
    }
    private get consumptionsCountWithDelay(): number {
        return this.requestsData!.countWithDelay;
    }
    private get consumptionsCountTotal(): number {
        return this.requestsData!.getTotalRequestCount();
    }

}
